module.exports = __webpack_public_path__ + "img/lenovo-review-avatar.a16385d.jpg";